var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Pipe } from '@angular/core';
import { Post } from '../models/post';
export var OtherUsersPostsPipe = (function () {
    function OtherUsersPostsPipe() {
    }
    OtherUsersPostsPipe.prototype.transform = function (allPosts, owner) {
        if (allPosts == null) {
            return allPosts;
        }
        if (!owner) {
            return allPosts;
        }
        return allPosts.filter(function (x) { return x.owner != owner; });
    };
    OtherUsersPostsPipe = __decorate([
        Pipe({ name: 'OtherUsersPosts' }), 
        __metadata('design:paramtypes', [])
    ], OtherUsersPostsPipe);
    return OtherUsersPostsPipe;
}());
export var PostMapPipe = (function () {
    function PostMapPipe() {
    }
    PostMapPipe.prototype.transform = function (allPosts) {
        if (allPosts == null) {
            return allPosts;
        }
        return allPosts.map(function (p) { return Post.create(p); });
    };
    PostMapPipe = __decorate([
        Pipe({ name: 'PostMap' }), 
        __metadata('design:paramtypes', [])
    ], PostMapPipe);
    return PostMapPipe;
}());
